<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";
import type { Price } from "mws-ts-v2-sdk";

import { queries } from "~/queries";

const { selectedPaymentTokenId } = defineProps<{
  selectedPaymentTokenId: string;
  reservationAmount: Price;
}>();

const { data: paymentTokens } = useQuery(queries.tokens.list());

const selectedCard = computed(() =>
  paymentTokens.value?.results.find(
    (token) => token.id === selectedPaymentTokenId,
  ),
);
</script>

<template>
  <BaseInfoMessage
    variant="action"
    :title="$t('product.cardReservationMessage.title')"
    class="mb-5"
  >
    <I18nT
      v-if="reservationAmount.currency && selectedCard"
      scope="global"
      keypath="product.cardReservationMessage.cardSelected"
      tag="p"
    >
      <template #PLACEHOLDER_amount>
        <BaseCurrency
          :value="reservationAmount.price"
          :iso="reservationAmount.currency"
        />
      </template>
      <template #PLACEHOLDER_cardNumber>
        {{ selectedCard.cardNumber }}
      </template>
    </I18nT>
  </BaseInfoMessage>
</template>
